import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  DarkMode,
  DarkModeState,
} from 'web-component-library/projects/component-library/src/public-api';
import {
  DarkModeSetting,
  DarkModeSettingType,
} from '@app/model/payment-request/payment-request.dto';

@Injectable({
  providedIn: 'root',
})
export class DarkModeService implements DarkMode {
  darkModeState: DarkModeState = DarkModeState.LIGHT;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.applyTheme();
  }

  public setModeFromBackend(themeSetting: DarkModeSettingType) {
    let uiState: DarkModeState;

    switch (themeSetting) {
      case DarkModeSetting.DARK:
        uiState = DarkModeState.DARK;
        break;
      case DarkModeSetting.SYSTEM:
        uiState = DarkModeState.SYSTEM;
        break;
      case DarkModeSetting.LIGHT:
      default:
        uiState = DarkModeState.LIGHT;
        break;
    }

    this.applyTheme(uiState);
  }

  public applyTheme(newTheme?: DarkModeState) {
    if (newTheme) {
      this.darkModeState = newTheme;
    }

    if (this.darkModeState === DarkModeState.DARK) {
      this.document.body.setAttribute('data-theme', 'dark');
    } else {
      this.document.body.setAttribute('data-theme', 'light');
    }
  }
}
